import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { Subject, takeUntil } from 'rxjs';
import { AppState } from 'src/app/app.state';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css'],
})
export class StepperComponent {
  @Input() currentIndex: number;
  @Input() isCompleted: boolean;

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public appState: AppState,
    private cdr: ChangeDetectorRef,
  ) { };

  onDestroyNotifier$ = new Subject();
  historyState: any;
  completedIndex: any;
  reachedIndex: any;
  isBasicHomeExpanded: boolean = false;
  isMobileStepperExpanded: boolean = false;
  isSubStep: boolean = false;
  singleFormSubmit: boolean = true;

  public toggleButton(): void {
    this.isBasicHomeExpanded = !this.isBasicHomeExpanded;
    this.localStorageService.set('isBasicHomeExpanded', this.isBasicHomeExpanded);
  }
  public mobileToggle(): void {
    this.isMobileStepperExpanded = !this.isMobileStepperExpanded;
  }
  steps = [
    {
      index: 1,
      step: 'Home Details',
      isCompleted: false,
      subSteps: [
        { index: 1.1, step: 'Basic Home Details', isCompleted: true },
        { index: 1.2, step: 'Parking', isCompleted: false },
        { index: 1.3, step: 'Basement', isCompleted: false },
        { index: 1.4, step: 'Interior', isCompleted: false },
        { index: 1.5, step: 'Exterior', isCompleted: false },
        { index: 1.6, step: 'Listing Details', isCompleted: false },
        { index: 1.7, step: 'Photos', isCompleted: false },
      ],
    },
    {
      index: 2,
      step: 'Plan',
      isCompleted: false,
      subSteps: [],
    },
    {
      index: 3,
      step: 'Payment',
      isCompleted: false,
      subSteps: [],
    },
  ];

  ngOnInit(): void {

    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {

      if (res) {

        if (res?.sellSideConfig && res?.sellSideConfig?.singleFormSubmit) {
          this.singleFormSubmit = true;
          this.steps[0].step = 'Listing Details';
          this.steps[0].subSteps = [];
        } else {
          this.singleFormSubmit = false;
        }

        if (res?.sellSideConfig && res?.sellSideConfig?.hidePlanSelection) {
          this.steps = this.steps.slice(0, -2); // Removes the last two elements
        }

      }
      this.cdr.detectChanges();

    });
    this.historyState = history.state;
    this.completedIndex = this.historyState.completedIndex;

    if (this.singleFormSubmit && this.historyState?.isPaymentDone ) {
      this.steps[1].step = 'Photos';
      this.steps[1].subSteps = [];
    }

    this.isBasicHomeExpanded = this.localStorageService.get('isBasicHomeExpanded') == 'true' ? true : false;

    if (this.historyState.isPaymentDone) {
      this.reachedIndex = this.currentIndex;
    } else {
      this.reachedIndex = this.currentIndex > this.completedIndex ? this.currentIndex : this.completedIndex;
    }

    

    // console.log("this.reachedIndex :", this.reachedIndex);

    if (this.reachedIndex < 2) {
      for (let index = 0; index < this.steps[0].subSteps.length; index++) {
        if (this.steps[0].subSteps[index].index <= this.reachedIndex) {
          this.steps[0].subSteps[index].isCompleted = true;
        }
      }
    } else if (this.reachedIndex == 2) {
      this.steps[0].isCompleted = true;
    } else if (this.reachedIndex == 2.1) {
      // for (let index = 0; index < 3; index++) {
      //   this.steps[index].isCompleted = true;
      // }
      this.steps[0].isCompleted = true;
      // this.steps[3].subSteps[0].isCompleted = true;
      this.steps[1].subSteps[0].isCompleted = true;
    }
    else {
      for (let index = 0; index < this.reachedIndex - 1; index++) {
        this.steps[index].isCompleted = true;
      }
    }

    if (this.historyState.isPaymentDone && this.steps.length == 3) {
      this.steps.splice(2, 1);
      this.isBasicHomeExpanded = true;
    }
  }

  goToStep(step) {
    if (!this.isSubStep) {
      // if (step.index <= this.reachedIndex) {
      if (step.index == 1) {
        if (this.singleFormSubmit) {
          this.router.navigateByUrl('/home-details', {
            state: this.historyState
          });
        } else {
          this.toggleButton();
        }
      }
      // else if (step.index == 2) {
      //   this.router.navigateByUrl('/listing-details', {
      //     state: this.historyState
      //   });
      // } else if (step.index == 3) {
      //   this.router.navigateByUrl('/photos', {
      //     state: this.historyState
      //   });
      // } 
      else if (step.index == 2 && step.step == 'Photos') {
        this.router.navigateByUrl('/photos', {
          state: this.historyState
        });
      } 
      else if (step.index == 2 && step.index <= this.reachedIndex) {
        this.router.navigateByUrl('/plans', {
          state: this.historyState
        });
      } else if (step.index == 3 && step.index <= this.reachedIndex) {
        this.router.navigateByUrl('/review', {
          state: this.historyState
        });
      }
      // }
    }
  }

  goToSubStep(subStep) {
    this.isSubStep = true;
    // if (subStep.index <= this.reachedIndex) {
    if (subStep.index == 1.1) {
      this.router.navigateByUrl('/home-details', {
        state: this.historyState
      });
    } else if (subStep.index == 1.2) {
      this.router.navigateByUrl('/parking', {
        state: this.historyState
      });
    } else if (subStep.index == 1.3) {
      this.router.navigateByUrl('/basement', {
        state: this.historyState
      });
    } else if (subStep.index == 1.4) {
      this.router.navigateByUrl('/interior', {
        state: this.historyState
      });
    } else if (subStep.index == 1.5) {
      this.router.navigateByUrl('/exterior', {
        state: this.historyState
      });
    } else if (subStep.index == 1.6) {
      this.router.navigateByUrl('/listing-details', {
        state: this.historyState
      });
    } else if (subStep.index == 1.7) {
      this.router.navigateByUrl('/photos', {
        state: this.historyState
      });
    }
    // else if (subStep.index == 2.1 && subStep.index <= this.reachedIndex) {
    //   this.router.navigateByUrl('/addon', {
    //     state: this.historyState
    //   });
    // }
    // }
  }
}
